import React from 'react'
import PropTypes from 'prop-types'
import styles from './modalFeedback.module.scss'

const ModalFeedback = ({ visible, closeCallback, children }) => {
  return (
    <div
      className={`${styles.modal} ${visible ? 'visible' : ''}`}
      style={{ display: visible ? 'block' : 'none' }}
    >
      <div className={styles.modalContainer}>
        <div className={styles.headerModal}>
          <button type="button" onClick={() => closeCallback()}>
            X
          </button>
        </div>
        <div className={styles.modalContent}>{children}</div>
      </div>
    </div>
  )
}

ModalFeedback.defaultProps = {
  visible: true
}

ModalFeedback.propTypes = {
  visible: PropTypes.bool,
  closeCallback: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string
  ]).isRequired
}

export default ModalFeedback
